export default __webpack_public_path__ + "7f8f7aa003807196d66fb2969b08f0a3.svg";